import { render } from "./PageAddUser.vue?vue&type=template&id=bf8e91a8"
import script from "./PageAddUser.vue?vue&type=script&lang=js"
export * from "./PageAddUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__